"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransaction = void 0;
const transaction_js_1 = require("../../errors/transaction.js");
const toHex_js_1 = require("../../utils/encoding/toHex.js");
const transaction_js_2 = require("../../utils/formatters/transaction.js");
async function getTransaction(client, _ref) {
  var _client$chain;
  let {
    blockHash,
    blockNumber,
    blockTag: blockTag_,
    hash,
    index
  } = _ref;
  const blockTag = blockTag_ || 'latest';
  const blockNumberHex = blockNumber !== undefined ? (0, toHex_js_1.numberToHex)(blockNumber) : undefined;
  let transaction = null;
  if (hash) {
    transaction = await client.request({
      method: 'eth_getTransactionByHash',
      params: [hash]
    });
  } else if (blockHash) {
    transaction = await client.request({
      method: 'eth_getTransactionByBlockHashAndIndex',
      params: [blockHash, (0, toHex_js_1.numberToHex)(index)]
    });
  } else if (blockNumberHex || blockTag) {
    transaction = await client.request({
      method: 'eth_getTransactionByBlockNumberAndIndex',
      params: [blockNumberHex || blockTag, (0, toHex_js_1.numberToHex)(index)]
    });
  }
  if (!transaction) throw new transaction_js_1.TransactionNotFoundError({
    blockHash,
    blockNumber,
    blockTag,
    hash,
    index
  });
  const format = ((_client$chain = client.chain) === null || _client$chain === void 0 || (_client$chain = _client$chain.formatters) === null || _client$chain === void 0 || (_client$chain = _client$chain.transaction) === null || _client$chain === void 0 ? void 0 : _client$chain.format) || transaction_js_2.formatTransaction;
  return format(transaction);
}
exports.getTransaction = getTransaction;
//# sourceMappingURL=getTransaction.js.map